import * as angular from "angular";

export class TalkingPointCategoryService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/talkingpoint/category";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }
}

angular
    .module("vcServices")
    .service("TalkingPointCategoryService", TalkingPointCategoryService);
